<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2A1nW9/tc-custom/9781682303542.jpg?1736858029008" alt="This image is the cover for the book Crystal Clear"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crystal Clear
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i></b><b>-Bestselling Author: A trip to Sedona, a disappearing heiress, and a reappearing ex-husband add up to trouble for a straitlaced accountant…</b><br/>  <br/> No one craves order more than bean counter Crystal Goldstein. A partner at a New York accounting firm, doting daughter to her aging father, and loyal girlfriend to the equally workaholic Steven, she has her life completely under control. But when she learns that Steven’s been cheating on her with his ex-wife, that her gruff father has spent years yearning for a brother she never knew she had, and that her job may be in jeopardy, she’s brought up really short.<br/>  <br/> Crystal's best friend—a New Age junkie—convinces her that her aura needs cleansing and her chakras need balancing. With nothing to lose, Crystal takes a long-overdue vacation in mystical, metaphysical Sedona, Arizona. Among the resort’s guests: Amanda Wells Reid, international jet-setter, consummate party-goer, and darling of the society columnists, along with her personal assistant, personal chef, personal trainer, and personal publicist. And their tour driver is none other than the totally irresistible, totally irresponsible husband Crystal tossed out so many years ago.<br/>  <br/> It doesn’t take a psychic to know that the mix of a reappearing ex-husband whose appeal has only ripened and a millionaire heiress who suddenly vanishes is going to add up to some pretty eye-opening—and mind-expanding—doings….<br/>  <br/> “A modern spin on a good old-fashioned Cinderella story.”—<i>Kirkus Reviews</i><br/>  <br/> “Jane Heller’s special gift for lampooning the pompous and self-absorbed make for enormously funny reading. <i>Crystal Clear</i> will have you snickering from beginning to end.”—<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Heller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14f909bc